module.exports = __webpack_public_path__ + "media/images/flags/16/Colombia-efe8e8ffb09a0abdc9648774661b56a0.png";